<template>
  <section>
    <p><strong>{{ pickup.sender ? pickup.sender.organisation_name : '-' }}</strong></p>
    <p><strong>{{ pickup.sender ? `${pickup.sender.first_name || ''} ${pickup.sender.last_name || ''}` : '' }}</strong></p>
    <p>{{ pickup.sender ? `${pickup.sender.address_line1 || ''} ${pickup.sender.address_line2 || ''} ${pickup.sender.locality || ''} ${pickup.sender.administrative_area || ''} ${pickup.sender.postal_code || ''} ${pickup.sender.country || ''}` : '' }}</p>
    <p>
      <a
        v-if="pickup.sender && pickup.sender.phone"
        :href="`tel:${pickup.sender.phone}`"
      >
        {{ pickup.sender.phone }}
      </a>
    </p>
    <a
      v-if="pickup.sender && pickup.sender.email"
      :href="`mailto:${pickup.sender.email}`"
    >
      {{ pickup.sender.email }}
    </a>
  </section>
</template>

<script>
export default {
  props: {
    pickup: {
      type: Object,
      required: true
    }
  }
}
</script>
